import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { useQuery } from 'src/utils/hooks/useQuery'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { FetchPartnerPublicInfo, Logout } from 'src/constants/actionTypes'
import qs from 'query-string'
import _ from 'lodash'
import { PartnerPublicInfo } from 'src/interfaces/partner'
import { getPartner } from 'src/selectors/partner'

export const ClientSignedUpPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const { getQuery, getQueryAsArray } = useQuery()

  const partnerMarketId = getQuery('partnerMarketId')
  const onboardingTemplateId = getQuery('onboardingTemplateId')
  const phone = getQuery('phone')
  const email = getQuery('email')
  const firstName = getQuery('firstName')
  const lastName = getQuery('lastName')
  const referral = getQuery('referral')
  const tagNames = getQueryAsArray('tags') || []

  const partner = useSelector(getPartner)

  useEffect(() => {
    if (!params?.partnerName || !partnerMarketId || !onboardingTemplateId || !partner?.name) {
      return
    }

    const handleLogout = async () => {
      try {
        const publicPartner: PartnerPublicInfo = await createAsyncAction(
          dispatch,
          FetchPartnerPublicInfo.request({ partnerName: params?.partnerName }),
        )

        if (partner?.name === publicPartner?.name) {
          navigate(CLIENT_ROUTES.HOME_URL)

          return
        }

        await createAsyncAction(dispatch, Logout.request())

        navigate(
          `/client/${params.partnerName}/sign-up?${qs.stringify(
            _.omitBy(
              {
                partnerMarketId,
                onboardingTemplateId,
                phone,
                email,
                firstName,
                lastName,
                referral,
                tagNames,
              },
              _.isNil,
            ),
            { encode: false },
          )}`,
        )
      } catch (error) {
        navigate(CLIENT_ROUTES.HOME_URL)
      }
    }

    handleLogout()
  }, [
    params?.partnerName,
    partnerMarketId,
    onboardingTemplateId,
    phone,
    email,
    firstName,
    lastName,
    referral,
    tagNames,
    partner?.name,
  ])

  if (!params?.partnerName || !partnerMarketId || !onboardingTemplateId) {
    return <Navigate to={CLIENT_ROUTES.HOME_URL} />
  }

  return null
}
